<!-- Documentation -->
<!-- https://docs.google.com/presentation/d/18i-61r_Oyd1RSZ2gVCbacxJQ64v6JhQiC0gYr8tGnNs/edit#slide=id.g1cf0f964887_0_12 -->
<!-- https://xd.adobe.com/view/d3a0016d-0148-4820-871d-6757f32740ff-86f3/screen/c0681546-0766-4a82-a2da-631083c7cb04/ 
https://xd.adobe.com/view/f344cbd5-67ae-4ef0-8cfc-8b8f917363a3-a617/
mobile
https://xd.adobe.com/view/f344cbd5-67ae-4ef0-8cfc-8b8f917363a3-a617/screen/5aed5750-a5d4-4dc4-9b28-5d8e1cc4c604/specs/   
https://xd.adobe.com/view/5524bc38-136d-4e9b-b282-a0d9015c7c1f-0077/
https://docs.google.com/presentation/d/17jyzC7801QF3CLG9w0gwZxDq-c9DCdAFYvUv_UeH25Q/edit#slide=id.p  issues
https://docs.google.com/presentation/d/1MK4ZMITWJGMF4Cfm3DvWHVrx1jtoSg997hw17GXjEGI/edit#slide=id.p user guide
https://xd.adobe.com/view/6eab2142-762a-448d-a474-12e6d57ab4e3-3bf8/
https://xd.adobe.com/view/fea5975d-a34d-4daa-89c7-b018455dfa55-abf6/screen/8245b8d4-7ba8-4266-9976-09b19e3900d7/ app
https://xd.adobe.com/view/6eab2142-762a-448d-a474-12e6d57ab4e3-3bf8/screen/2e13c91f-6fd6-4720-a2b9-ddf5af1be2d9/
-->
<template>
  <div id="allofferproduct" clas="mx4 my3 flex-column darkblue notosans xs-p0" >
    <template>
      <div class="clearfix mx-auto" v-if="loading">
        <div class="col-12 ">
          <div class="loader"></div>
        </div>
      </div>
      <div class="clearfix col-12 pr4 noto-sans darkblue xs-px3" v-else>
            <div class="col-12 px0">
              <div class="flex justify-start mt3">
                <p class="h3 semi-bold line-height-2 my2 darkblue">
                  Opret tilbud
                </p>
              </div>  
              <p class="h5 regular darkblue line-height-golden my1">
                Send tilbud til kunden:
              </p>
            </div>
            <div class="py1"></div>
            <div class="clearfix mx-auto" v-if="loading">
              <div class="col-12">
                <div class="loader"></div>
              </div>
            </div>
            <div class="col-12 pr4 xs-p0 m0" v-else>
            <form-wizard ref="createofferwizard" id="createofferwizard" title="" subtitle="" shape="circle" color="rgba(25, 163, 192, 1.0)" error-color="rgba(207,0,15,1.0)" finishButtonText="Bekræft">
              <tab-content title="Trin 1" :before-change="validateFirstTab">
                  <div>
                  <el-collapse v-model="activeTab">
                    <el-collapse-item class="darkblue-background" title="" name="1" >
                      <p slot="title" class="h5 semi-bold px2 m0 ">Tilbudsliste</p>
                      <div class="darkblue center mb3 mt4" v-if="Object.entries(productlistforpricearr).length < 1"><p class="m0 p0 ">Ingen opgave er relateret til din primære branche <span class="bold">{{partnerprimaryindustryText}}</span> for dette job, men du kan anmode nedenfor</p>
                      </div>
                      <div v-else>
                        <div class="my3">
                          <el-form :model="productOfferForm" :rules="productOfferFormRules" class=" p0 m0 md-col-12 lg-col-12 sm-col-12 xd-col-12" ref="productOfferForm" label-position="top">
                            <div class="flex flex-column mb2 border border-left-0 border-top-0 border-right-0 muted-border pb2" v-for="(industryfields,index) in Object.entries(productlistforpricearr)" :key="industryfields[0]">
                                <p class="m0 p0 h4 my1">{{parseInt(index + 1) + '. '}}{{mainwizarproductarr[industryfields[0]]}}</p>
                                <div class="xs-mb2 q" v-for="(jobitem,index2) in Object.entries(productlistforpricearr[industryfields[0]])" :key="index2">
                                  <div class="flex items-center">
                                    <p class="m0 pl3 h4 xs-pl1 my1 primarycolor">{{parseInt(index + 1) + '.'}}{{index2 + 1 + ' '}} {{itemsjobindustry[jobitem[0]]}}</p>
                                    <div class="m0 p0 lg-col-1 md-col-1 xs-col-5 sm-col-1 ml-auto ">
                                      <el-form-item :props="industryfields[0] + '_' + jobitem[0]" class="primarycolor-border m0">
                                          <el-input-number v-model.number="productOfferForm[industryfields[0] + '_' + jobitem[0]]" :id="industryfields[0] + '_' + jobitem[0]" @change="computetotal(productOfferForm[industryfields[0] + '_' + jobitem[0]], industryfields[0] + '_' + jobitem[0])"  placeholder="pris" class="inputnumberamout white-background"></el-input-number>
                                      </el-form-item>
                                    </div>
                                  </div>
                                  <!-- eslint-disable -->
                                  <div class="flex justify-end col-12 p0 m0 mt2">
                                    <p class="p0 m0 pointer" @click="jobDescRestoreAll(industryfields[0], jobitem[0])">
                                      <i class="el-icon-refresh-left primarycolor h5"></i>
                                      <span class="primarycolor">Gendan tekst</span>
                                    </p>
                                  </div>
                                  <div class="mt2" v-for="(itemfields,index3) in jobitem[1].SERIESARR" :key="index3" v-if="itemfields.descr !== ''">
                                    <div class="m0 p0 mp0 lg-col-12 md-col-12 xs-col-12 sm-col-12 mr-auto" v-if="!editdescfield">
                                      <div class="m0 pl4 xs-pl2 flex items-start">
                                        <span class="">{{parseInt(index + 1) + '.' + parseInt(index2 + 1) + '.' + parseInt(index3 + 1)}}</span>
                                        <input class="sm-col-10 md-col-10 lg-col-11 xxl-col-11 px2 m0 ml1" v-model="itemfields.newdesctext" v-if="itemfields.isediting" />
                                        <div class="pl1 h6" v-else>{{itemfields.descr}}</div>
                                        <div class="flex justify-end ml-auto gap-15" v-if="itemfields.isediting">
                                          <el-tooltip content="Afbestille" placement="top">
                                            <button type="button" class="transparent m0 border-0 p0" @click="jobDescCanceledit(industryfields[0], jobitem[0], index3)">
                                              <i class="el-icon-close primarycolor h3"></i>
                                            </button>
                                          </el-tooltip>
                                          <el-tooltip content="Gemme" placement="top">
                                            <button type="button" class="transparent m0 border-0 p0" @click="jobDescAddandEdit(industryfields[0], jobitem[0], index3)">
                                              <i class="el-icon-check primarycolor h3"></i>
                                            </button>
                                          </el-tooltip>
                                        </div>
                                        <div class="flex justify-end ml-auto gap-15" style="height: 24px;" v-else>
                                          <el-tooltip content="Redigere" placement="top">
                                            <button type="button" class="transparent border-0 m0 p0" @click="jobDescEdit(industryfields[0], jobitem[0], index3)">
                                              <svg xmlns="http://www.w3.org/2000/svg" width="23.769" height="24.001" viewBox="0 0 28.769 29.001">
                                                <g id="Icon_feather-edit" data-name="Icon feather-edit" transform="translate(1 1.232)">
                                                  <path id="Path_4220" data-name="Path 4220" d="M14.973,6H5.661A2.661,2.661,0,0,0,3,8.661V27.286a2.661,2.661,0,0,0,2.661,2.661H24.286a2.661,2.661,0,0,0,2.661-2.661V17.973" transform="translate(-3 -3.178)" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                                  <path id="Path_4221" data-name="Path 4221" d="M25.969,3.645A2.822,2.822,0,0,1,29.96,7.636L17.322,20.274,12,21.6l1.33-5.322Z" transform="translate(-4.018 -2.818)" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                                </g>
                                              </svg>
                                            </button>
                                          </el-tooltip>
                                          <el-tooltip content="Slet" placement="top">
                                            <button type="button" class="transparent border-0 m0 p0" @click="jobDescDelete(industryfields[0], jobitem[0], index3)">
                                              <svg xmlns="http://www.w3.org/2000/svg" width="20.947" height="23.608" viewBox="0 0 25.947 28.608">
                                                <g id="Icon_feather-trash-2" data-name="Icon feather-trash-2" transform="translate(1 1)">
                                                  <path id="Path_4222" data-name="Path 4222" d="M4.5,9H28.447" transform="translate(-4.5 -3.678)" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                                  <path id="Path_4223" data-name="Path 4223" d="M26.125,8.322V26.947a2.661,2.661,0,0,1-2.661,2.661h-13.3A2.661,2.661,0,0,1,7.5,26.947V8.322m3.991,0V5.661A2.661,2.661,0,0,1,14.152,3h5.322a2.661,2.661,0,0,1,2.661,2.661V8.322" transform="translate(-4.839 -3)" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                                  <path id="Path_4224" data-name="Path 4224" d="M15,16.5v7.982" transform="translate(-5.687 -4.527)" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                                  <path id="Path_4225" data-name="Path 4225" d="M21,16.5v7.982" transform="translate(-6.366 -4.527)" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                                </g>
                                              </svg>
                                            </button>
                                          </el-tooltip>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- eslint-enable -->
                                <div class="md-col-7 lg-col-7 xxl-col-6 sm-col-7 xs-col-8 flex justify-end items-center p0 m0 mt2 ml-auto " v-if="!hideplusbutton">
                                  <p class="p0 m0 flex items-center gap-15" @click="jobDescAddlineDesc(industryfields[0], jobitem[0])">
                                  <span >
                                    <svg svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="#ffff" stroke="#19a3c0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
                                  </span>
                                  <span class="h5 primarycolor">Tilføj beskrivelse</span>
                                  </p>
                                </div>
                                </div>
                            </div>
                          </el-form>
                        </div>
                        <div class="flex flex-column col-12 px0 mx-auto my3 pl2">
                          <div div class="h6 flex my1 p0 col-12"><p class="m0 p0 col-4">Samlet pris ekskl. moms</p><p class="m0 p0 col-8 flex justify-end">{{total.toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})}}</p></div>
                          <div div class="h6 flex my1 p0 col-12"><p class="m0 p0 col-4">25% moms</p><p class="m0 p0 col-8 flex justify-end">{{parseFloat(total * .25).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})}}</p></div>
                          <div class="h6 flex my1 p0 col-12"><p class="m0 p0 col-4">Samlet pris inkl. moms</p><p class="m0 p0 col-8 flex justify-end">{{(parseFloat(total * 1.25)).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})}}</p></div>
                        </div>
                      </div>
                    </el-collapse-item>
                    <el-collapse-item title="" name="2" v-if="Object.entries(productlistnotforpartnerArr).length > 0">
                    <p slot="title" class="h5 semi-bold px2 m0 ">Se andre entrepriser</p>
                    <div class="flex flex-column darkblue mt2">
                      <!-- eslint-disable -->
                      <div class="m0 flex flex-column my1" v-for="(item,index) in Object.entries(productlistnotforpartnerArr)" :key="index" v-if="Object.entries(productlistnotforpartnerArr[item[0]]).length > 0 && contractType === 'Fagentreprise'">
                        <p class="m0 py0 h6 my1 flex items-center semi-bold">{{mainwizarproductarr[item[0]]}}</p>
                        <div class="flex flex-row mt1" v-for="(jobindu,index2) in productlistnotforpartnerArr[item[0]]" :key="index2">
                          <div class="muted-background onmobilexd flex justify-start lg-col-9 sm-col-12 xs-col-12 m0 p0 xs-py1">
                            <p class="m0 px3 py0 h6 my1 flex items-center semi-bold">{{itemsjobindustry[jobindu.jobindustry]}}</p>
                            <span class="md-hide lg-hide xxl-hide ml-auto px3" @click="requestToHomeowner(jobindu.wizardId, jobindu.jobindustry)">
                              <svg xmlns="http://www.w3.org/2000/svg" class="primarycolor-fill" width="26" height="28.918" viewBox="0 0 26 28.918">
                                <g id="lock_ic" transform="translate(-2.227 -1)">
                                  <rect id="Rectangle_1355" data-name="Rectangle 1355" width="24" height="15" rx="2" transform="translate(3.227 13.918)" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                  <path id="Path_4023" data-name="Path 4023" d="M7,14.113V8.73a6.73,6.73,0,0,1,13.459,0v5.384" transform="translate(1.384 0)" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                </g>
                              </svg>
                            </span>
                          </div>
                          <div class="darkblue-background py1 px2 flex justify-center item-center ml-auto ml1 col-3 pointer xs-hide" @click="requestToHomeowner(jobindu.wizardId, jobindu.jobindustry)">
                            <span class="white">
                              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="28.918" viewBox="0 0 26 28.918">
                                <g id="lock_ic" transform="translate(-2.227 -1)">
                                  <rect id="Rectangle_1355" data-name="Rectangle 1355" width="24" height="15" rx="2" transform="translate(3.227 13.918)" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                  <path id="Path_4023" data-name="Path 4023" d="M7,14.113V8.73a6.73,6.73,0,0,1,13.459,0v5.384" transform="translate(1.384 0)" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                </g>
                              </svg>
                            </span>
                            <span class="white regular h6 m0 flex items-center  pl1">Anmod om at afgive tilbud</span>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div  v-for="(jobindu,index2) in Object.entries(productlistnotforpartnerArr)" :key="index2">
                        <div class="flex flex-row mt1" v-for="(jobindus,index23) in productlistnotforpartnerArr[item[0]]" :key="index23">
                          <div class="muted-background onmobilexd flex justify-start lg-col-9 sm-col-12 xs-col-12 m0 p0 xs-py1">
                            <p class="m0 px3 py0 h6 my1 flex items-center semi-bold">{{itemsjobindustry[jobindus.jobindustry]}}</p>
                            <span class="md-hide lg-hide xxl-hide ml-auto px3" @click="requestToHomeowner(jobindus.wizardId, jobindus.jobindustry)">
                              <svg xmlns="http://www.w3.org/2000/svg" class="primarycolor-fill" width="26" height="28.918" viewBox="0 0 26 28.918">
                                <g id="lock_ic" transform="translate(-2.227 -1)">
                                  <rect id="Rectangle_1355" data-name="Rectangle 1355" width="24" height="15" rx="2" transform="translate(3.227 13.918)" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                  <path id="Path_4023" data-name="Path 4023" d="M7,14.113V8.73a6.73,6.73,0,0,1,13.459,0v5.384" transform="translate(1.384 0)" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                </g>
                              </svg>
                            </span>
                          </div>
                          <div class="darkblue-background py1 px2 flex justify-center item-center ml-auto ml1 col-3 pointer xs-hide" @click="requestToHomeowner(jobindus.wizardId, jobindus.jobindustry)">
                            <span class="white">
                              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="28.918" viewBox="0 0 26 28.918">
                                <g id="lock_ic" transform="translate(-2.227 -1)">
                                  <rect id="Rectangle_1355" data-name="Rectangle 1355" width="24" height="15" rx="2" transform="translate(3.227 13.918)" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                  <path id="Path_4023" data-name="Path 4023" d="M7,14.113V8.73a6.73,6.73,0,0,1,13.459,0v5.384" transform="translate(1.384 0)" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                </g>
                              </svg>
                            </span>
                            <span class="white regular h6 m0 flex items-center  pl1">Anmod om at afgive tilbud</span>
                          </div>
                        </div>
                        </div>
                      </div>
                      <!-- eslint-enable -->
                    </div>
                    </el-collapse-item>
                  </el-collapse>
                  </div>
              </tab-content>
              <tab-content title="Trin 2" :before-change="validateSecondTab">
                    <div class="flex flex-column mb2 col-12 mx-auto p0">
                        <div div class="m0 p0 pl2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6 mr-auto">
                          <p>Hvor lang tid estimerer du, at projektet tager?</p>
                        </div>
                        <div class="m0 p0 lg-col-5 md-col-5 xs-col-12 sm-col-5">
                              <el-input type="number" @input="limitdays()" v-model="daystofinish" class="daystofinish white-background" placeholder="Antal dage til at afslutte jobbet" ></el-input>
                        </div>
                        <el-alert v-if="limitdayserror" title="dette er begrænset til 1500 dage" type="error" :closable="false" show-icon></el-alert>
                    </div>
                    <div class="flex flex-column mb2 col-12 mx-auto p0">
                        <div div class="m0 p0 pl2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6 mr-auto">
                          <p>Hvilken dato kan du starte på projektet?</p>
                        </div>
                        <div class="m0 p0 lg-col-5 md-col-5 xs-col-12 sm-col-5">
                              <el-date-picker type="datetime" v-model="datestart" :picker-options="pickerOptions" format="yyyy-MM-dd" value-format="yyyy-MM-dd" class=" white-background" placeholder="Startdato for jobbet" ></el-date-picker>
                        </div>
                    </div>
              </tab-content>
              <tab-content title="Trin 3" :before-change="validatethirdTab">
                  <div class="my2 col-12 mx-auto">
                    <span><el-checkbox v-model="savenote">Gem Som Standardtekst</el-checkbox></span>
                    <el-input type="textarea" v-model="partnernote" @change="alertpartnernote = false" :autosize="{ minRows: 4, maxRows: 6}" placeholder="Tilføj evt. forbehold eller særlige betingelser for dit tilbud">
                    </el-input>
                    <el-alert v-if="alertpartnernote" title="Skriv venligst dine tilbudsbemærkninger i dette felt" type="error" effect="light" show-icon :closable="false" class="line-height-1 mt1 col-12"></el-alert>
                  </div>
                  <div class="my2 col-12 mx-auto pointer flex items-center gap-10">
                    <p class="m0 underline primarycolor" @click="reviewsmodal = true"><i class="el-icon-circle-plus-outline primarycolor"></i>Tilføj din anbefaling</p> 
                    <i @click="reviewtext = true" class="el-icon-question"></i>
                  </div>
              </tab-content>
              <tab-content title="Trin 4">
                <div>
                  <p class="h3 semi-bold">Opsummering</p>
                  <div class="p0 m0 md-col-12 lg-col-12 sm-col-12 xd-col-12">
                    <div class="flex flex-column mb2 border border-left-0 border-top-0 border-right-0 muted-border pb2" v-for="(industryfields,index) in Object.entries(productlistforpricearr)" :key="industryfields[0]">
                      <p class="m0 p0 h4 my1">{{parseInt(index + 1) + '. '}}{{mainwizarproductarr[industryfields[0]]}}</p>
                      <div class="xs-mb2 q" v-for="(jobitem,index2) in Object.entries(productlistforpricearr[industryfields[0]])" :key="index2">
                        <div class="flex items-center col-12">
                          <p class="m0 pl3 h4 xs-pl1 my1 primarycolor">{{parseInt(index + 1) + '.'}}{{index2 + 1 + ' '}} {{itemsjobindustry[jobitem[0]]}}</p>
                          <p class="m0 p0 ml-auto ">{{(parseFloat(productOfferForm[industryfields[0] + '_' + jobitem[0]])).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})}}</p>
                        </div>
                        <!-- eslint-disable -->
                        <div class="mt1" v-for="(itemfields,index3) in jobitem[1].SERIESARR" :key="index3" v-if="itemfields.descr !== ''">
                          <div class="m0 p0 mp0 lg-col-12 md-col-12 xs-col-12 sm-col-12 mr-auto" v-if="!editdescfield">
                            <div class="m0 pl4 xs-pl2 flex items-start">
                              <span class="">{{parseInt(index + 1) + '.' + parseInt(index2 + 1) + '.' + parseInt(index3 + 1)}}</span>
                              <div class="pl1 h6">{{itemfields.descr}}</div>
                            </div>
                          </div>
                        </div>
                        <!-- eslint-enable -->
                      </div>
                    </div>
                    <div class="flex flex-column col-12 px0 mx-auto my3 border border-left-0 border-top-0 border-right-0 muted-border mb2">
                      <div div class="h6 flex my1 p0 col-12"><p class="m0 p0 lg-col-4 sm-col-4 md-col-4 xs-col-8">Samlet pris ekskl. moms</p><p class="m0 p0 col-8 flex justify-end">{{total.toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})}}</p></div>
                      <div div class="h6 flex my1 p0 col-12"><p class="m0 p0 lg-col-4 sm-col-4 md-col-4 xs-col-8">25% moms</p><p class="m0 p0 col-8 flex justify-end">{{parseFloat(total * .25).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})}}</p></div>
                      <div class="h6 flex my1 p0 col-12"><p class="m0 p0 lg-col-4 sm-col-4 md-col-4 xs-col-8">Samlet pris inkl. moms</p><p class="m0 p0 col-8 flex justify-end">{{(parseFloat(total * 1.25)).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})}}</p></div>
                    </div>
                    <div class="flex flex-column border border-left-0 border-top-0 border-right-0 muted-border">
                      <div class="flex mt2 col-12 mx-auto p0 ">
                            <div div class="m0 p0">
                              <p>Hvor lang tid estimerer du, at projektet tager?</p>
                            </div>
                            <div class="m0 p0 ml-auto">
                                <p>{{daystofinish}} Days</p>
                            </div>
                        </div>
                        <div class="flex my1 col-12 mx-auto p0">
                            <div div class="m0 p0 ">
                              <p>Hvilken dato kan du starte på projektet?</p>
                            </div>
                            <div class="m0 p0 ml-auto">
                                  <p>{{moment(datestart).locale('da').format('LL')}}</p>
                            </div>
                        </div>
                      </div>
                      <div class="col-12 mt1 m0 p0 flex flex-column py2">
                        <p class="h5 p0 m0 regular grey mb1 ">Standard tekst</p>
                        <p class="m0 p0">{{partnernote}}</p>
                      </div>
                  </div>
                </div>
              </tab-content>
              <template slot="footer" slot-scope="props">
                <div class="py2"></div>
                <div id="parentFooterButtons" class="flex justify-end gap-10">
                  <button @click="props.prevTab()" class="outlined-standard-button h5 semi-bold m0 line-height-4 regular py1 px3" v-if="props.activeTabIndex > 0">
                    <span class="inline-block">Tilbage</span>
                  </button>
                  <button @click="!props.isLastStep ? props.nextTab() : opensignature() " class="action-button next-button h5 semi-bold m0 line-height-4 regular py1 px3">
                    <span class="inline-block">{{!props.isLastStep ? 'Næste' : 'Færdig' }}</span>
                  </button>
                </div>
              </template>
            </form-wizard>
            </div>
            <div class="py3 lg-hide md-hide xxl-hide"></div>
      </div>
    </template>
    <b-modal  centered hide-header hide-footer id="signaturepopup" ref="signaturepopup">
      <div class="col-12 flex justify-end items-center white-background px0 ">
        <button type="button" @click="closesignature() " class="white-button no-border not-rounded gibson ">
          <span> <i class="el-icon-circle-close"></i> </span>
        </button>
      </div>
      <div class="py1 col-12 p0 relative overflow-hidden" style="height:95%;">
        <div class="flex col-12 p0">
          <p class="darkblue">Underskriv her</p>
          <p class="white-backgroud px2 ml-auto red h6" @click="clearSignature()"><i class="el-icon-close"></i> Ryd</p>
        </div>
        <div class="col-12 p0 border muted-border mx-auto"  id="signature-control" >
          <!-- <ejs-signature id="signature" class="mt0" height="300px" width="468px"></ejs-signature> -->
          <div id="signature-pad" class="signature-pad col-12 p0 height-full">
            <div class="signature-pad--body">
              <canvas width="460" style="touch-action: none; user-select: none;" height="290"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="my2 p0">
        <p class="m0">Totalbeløb inkl. moms: {{(parseInt(total * 1.25)).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})}}</p>
        <p class="m0">Startdato: {{moment(datestart).locale('da').format('LL')}}</p>
        <p class="m0" v-if="datestart">Estimeret slutdato: {{daystofinish}}</p>
      </div> -->
      <div class="col-12 p0 flex items-center mt2">
        <p class="mr-auto p0 py2 m0 h6 flex"><el-checkbox class="saveSignature" v-model="confirmTerms"><span class="pointer">{{termslabel}}</span></el-checkbox><span class="primarycolor semi-bold pl1 pointer" @click="opentermpopup()">{{termslinkablework}}</span></p>
        <button type="button" :disabled="!confirmTerms" class=" ml-auto action-button button-padding border-none not-rounded h5 regular line-height-1 p2" @click="submitOffer()">
          Færdig! Send tilbud
        </button>
      </div>
    </b-modal>
    <b-modal centered hide-header hide-footer id="successrequest" ref="successrequest">
        <div class="col-12 flex justify-start items-center white-background px0 ">
          <button type="button" @click="closerequestmodal() " class="white-button no-border not-rounded gibson ">
            <span> <i class="el-icon-back"></i> </span>
          </button>
        </div>
        <div class="clearfix white-background ">
          <div class="flex flex-column col-12 p0">
            <p class="my2 darkblue mx-auto">
              <img src="/static/gif/req_offer.gif" alt="Submit Request" />
            </p>
          </div>
        </div>
        <div class="col-12 flex justify-center items-center py1 mx">
          <button class="regular p2 px3 action-button center white" @click="requestToHomeowner(selectedindustryforrequest)"> Anmod om at afgive tilbud</button>
        </div>
    </b-modal>
    <b-modal centered hide-header hide-footer id="reviewsmodal" v-model="reviewsmodal" size="lg" ref="reviewsmodal">
        <div class="col-12 flex justify-start items-center white-background px0 ">
          <button type="button" @click="reviewsmodal = false" class="white-button no-border not-rounded gibson ">
            <span> <i class="el-icon-back"></i> </span>
          </button>
        </div>
        <div class="darkblue">
          <p class="">Vælg maks. 5 anmeldelser nedenfor for at inkludere dette i dit tilbud</p>
        </div>
        <div class="clearfix white-background ">
          <div class="col-12 mx0 px0 flex flex-wrap justify-around " >
            <div class="reviewsoffer mb2 shadow p2" v-for="review in allrecommendatationsitems" :key="review.id" :id="'box' + review.ReviewId " :class="fiverecommendations.includes(review.ReviewId) ? 'reviewbox' : null" >
                <div class="flex justify-between items-center">
                  <div class="flex col-12 p0">
                    <div class="flex flex-column mt1" >
                      <image-rating v-model="review.Rating" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="17" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
                    </div>
                    <div class="ml-auto">
                      <span v-if="review.AssignmentDistributedCount === 1" class="green">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -1.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-shield-check-f"><path d='M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z' /></svg>
                      </span>
                      <span v-else class="mediumgrey">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -1.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-shield-check-f"><path d='M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z' /></svg>
                      </span>
                    </div>
                </div>
              </div>
              <div class="mb3 xs-mb1">
                <p class="h6 darkblue mb0 relative">{{ moment(review.RatedDate).format('ll') }}</p>
              </div>
              <div class="flex flex-column col-12 p0">
                  <div class="">
                    <p class="m0 small">Overskrift</p>
                    <p class="m0" style="height: 39px;">{{review.Headline}}</p>
                  </div>
                  <el-collapse class="border-none">
                    <el-collapse-item title="Kommentar" :name="review.id">
                      <p class="h6 gibson mediumgrey break-word">{{ review.Comment}}</p>
                    </el-collapse-item>
                  </el-collapse>
              </div>
              <div>
                <p class="h5 darkblue semi-bold my2 line-height-golden">{{ review.RatedBy }}</p>
              </div>
              <div class="flex flex-row col-12 xs-p0">
                <button  type="button" class="ml-auto p2 px2 gibson dark-button z4 not-rounded flex justify-center items-center" @click="removethisrecommendation(review.ReviewId)" v-if="fiverecommendations.includes(review.ReviewId)">
                <i class="el-icon-minus"></i>
                <span class="h6 mb0 left-align pl1">Fjern dette</span>
                </button>
                <button type="button" id="addthisreview" class="ml-auto p2 px2 gibson z4 dark-button not-rounded flex justify-center items-center" @click="assignfiverecommendations(review.ReviewId)" v-if="!fiverecommendations.includes(review.ReviewId) && fiverecommendations.length <= 4">
                  <i class="el-icon-plus"></i>
                  <span class="h6 mb0 left-align pl1">Tilføj dette</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 flex justify-center items-center py1 mx">
          <button class="regular p2 px3 action-button center white" @click="addtoanswers()"> Tilføje</button>
        </div>
    </b-modal>
    <b-modal  centered hide-header size="lg" hide-footer id="termspopup" v-model="termspopup"  ref="termspopup">
      <div class="col-12 flex justify-end items-center white-background ">
        <button type="button" @click="termspopup = false" class="white-button no-border not-rounded gibson ">
          <span>
          <i class="el-icon-close"></i>
          </span>
        </button>
      </div>
      <div class="py1 col-12 relative" style="width:100%;height:95%;" >
        <iframe :src="termslink" frameborder="0" style="overflow:hidden;padding:10px;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px" height="100%" width="100%">
        </iframe>
      </div>
    </b-modal>
    <b-modal centered hide-header hide-footer id="reviewtext" v-model="reviewtext" ref="reviewtext">
        <div class="col-12 flex justify-end items-center white-background p2 ">
          <button type="button" @click="reviewtext = false " class="white-button no-border not-rounded ">
            <span> <i class="el-icon-close"></i> </span>
          </button>
        </div>
        <div class="col-12 flex justify-center items-center py2 mb2">
          <p class="m0 h5 center darkblue">Tilføj op til {{fiverecommendations.length + ' udvalgte anbefalinger, så kunden kan se, hvad andre har sagt om dig og dit arbejde'}}</p>
        </div>
    </b-modal>
    <b-modal centered hide-header hide-footer id="TermsNewPopup" v-model="TermsNewPopup" size="large" ref="TermsNewPopup">
        <div class="col-12 flex justify-end items-center white-background p2 ">
          <button type="button" @click="TermsNewPopup = false " class="white-button no-border not-rounded ">
            <span> <i class="el-icon-close"></i> </span>
          </button>
        </div>
        <div class="col-12 flex justify-center items-center py2 mb2">
          <div class="m0 h6 darkblue px3" v-html="termspopupText"></div>
          <!-- <b-embed type="iframe" scrolling="no" :src="termspopupText" aspect="21by9" class="col-12" height="120px"></b-embed> -->
        </div>
    </b-modal>
    <div class="py4"></div>
  <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  <noneligibleFeaturepop ref="noneligibleFeaturepop"></noneligibleFeaturepop>
  </div>
</template>
<script>
import noneligibleFeaturepop from './noneligibleFeaturepop'
import Simplert from 'vue2-simplert'
import { ImageRating } from 'vue-rate-it'
import SignaturePad from 'signature_pad'
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  name: 'tilbudpagwizardbooking',
  components: {
    Simplert,
    noneligibleFeaturepop,
    ErrorHandler,
    ImageRating,
    SignaturePad
  },
  data () {
    return {
      projectID: '',
      loading: true,
      activeTab: ['1'],
      contactID: '',
      salesPersonbitrix: '',
      partnernote: '',
      productOfferForm: {},
      productOfferPerForm: {},
      confirmTerms: false,
      haaid: '',
      productlistforpricearr: {},
      mainwizarproductarr: {},
      productlist: [],
      daystofinish: null,
      datestart: '',
      total: 0,
      reviewtext: false,
      childprojects: [],
      childprojectObj: {},
      rowbolig: [{
        title: '',
        description: '',
        unit: '',
        value: '',
        quantity: ''
      }],
      industrypris: {},
      startingno: 1,
      savenote: null,
      signaturePng: null,
      productOfferFormRules: {},
      offerID: null,
      partnerprimaryindustry: '',
      partnerprimaryindustryText: '',
      productrelatedbyPartnerPrimaryIndusty: [],
      productlistnotforpartnerArr: [],
      selectedindustryforrequest: '',
      alertpartnernote: false,
      summed: 0,
      editPriceArr: [],
      allrecommendatationsitems: [],
      fiverecommendations: [],
      reviewsmodal: false,
      productOfferFormEdit: {},
      parentID: '',
      industryID: [],
      offerType: '',
      itemsjobindustry: {},
      insurancetype: '',
      insuranceamount: 0,
      insurancepercentage: 0,
      parentofferId: '',
      submittedIndustries: [],
      contractType: '',
      projectTitle: '',
      jobList: [],
      createdFrom: '',
      partnerenterprise: '',
      termspopup: false,
      termsdata: [],
      termslabel: 'Accepter vores betingelser',
      termslink: 'http://www.haandvaerker.dk/om/betingelser',
      signaturePad: '',
      allprisperjob: [],
      termslinkablework: 'betingelser',
      jobdescarr: {},
      editdescfield: false,
      hideplusbutton: false,
      pickerOptions: {
        disabledDate (time) {
          return (time.getTime() - (-86400000)) < Date.now()
        }
      },
      limitdayserror: false,
      TermsNewPopup: false,
      termspopupText: ''
    }
  },
  created () {
  },
  watch: {
  },
  mounted () {
    // Fagentreprise
    // Hovedentreprise
    this.contactID = this.$route.query.contactID
    this.parentID = this.$route.query.parentID
    this.jobList = this.$route.query.joblist ? JSON.parse(this.$route.query.joblist) : []
    this.contractType = this.$route.query.contracttype ? this.$route.query.contracttype : null
    this.projectID = this.$route.query.projectID
    this.createdFrom = this.$route.query.createdfrom ? this.$route.query.createdfrom : null
    this.projectTitle = this.$route.query.projecttitle ? this.$route.query.projecttitle : null
    this.industryID = this.$route.query.industryID ? this.$route.query.industryID.split(',') : []
    this.submittedIndustries = this.$route.query.submittedindustry ? JSON.parse(this.$route.query.submittedindustry) : []
    this.offerType = this.$route.query.offertype ? this.$route.query.offertype : ''
    this.childprojects = this.$route.query.childprojects ? JSON.parse(this.$route.query.childprojects) : []
    if (this.contractType === 'Hovedentreprise') {
      if (this.createdFrom === 'bitrix') {
        if (this.parentID !== 'null') {
          this.jobList.forEach(k => {
            var jobindustry = k.split(':')[0]
            this.childprojectObj[Number(jobindustry)] = this.projectID
            this.submittedIndustries.push(jobindustry.toString())
          })
        } else {
          this.jobList.forEach(k => {
            k.forEach(p => {
              var jobindustry = p.split(':')[0]
              this.childprojectObj[Number(jobindustry)] = this.projectID
              this.submittedIndustries.push(jobindustry.toString())
            })
          })
        }
      } else {
        this.jobList.forEach(k => {
          if (Array.isArray(k)) {
            k.forEach(k => {
              var jobindustry = k.split(':')[0]
              this.submittedIndustries.push(jobindustry.toString())
            })
          } else {
            var jobindustry = k.split(':')[0]
            this.submittedIndustries.push(jobindustry.toString())
          }
        })
        if (this.childprojects.length > 0) {
          this.childprojects.forEach(o => {
            this.childprojectObj[o.JOB_INDUSTRY] = o.ID
          })
        }
      }
    } else {
      if (!this.parentID !== 'null') {
        this.jobList.forEach(p => {
          var jobindustry = p.split(':')[0]
          this.childprojectObj[Number(jobindustry)] = this.projectID
          this.submittedIndustries.push(jobindustry.toString())
        })
      } else {
        this.jobList.forEach(k => {
          k.forEach(p => {
            var jobindustry = p.split(':')[0]
            this.childprojectObj[Number(jobindustry)] = this.projectID
            this.submittedIndustries.push(jobindustry.toString())
          })
        })
      }
    }
    this.haaid = localStorage.getItem('haaid')
    if (localStorage.getItem('partnerPrimaryIndustryv2') === null || typeof localStorage.getItem('partnerPrimaryIndustryv2') === 'undefined') {
      this.$message.error('Log venligst på igen for at opdatere dine tilbudsoplysninger')
      this.$router.push('/login')
    }
    this.getenterprise()
    this.getallrecommendations()
    this.gettaskbitrix()
    this.getTermsCondition()
    this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
    this.partnerprimaryindustry = localStorage.getItem('partnerPrimaryIndustryv2')
    this.partnerprimaryindustryText = localStorage.getItem('partnerPrimaryIndustryText')
    this.getdataigibility()
  },
  methods: {
    getdataigibility () {
      setTimeout(() => {
        this.eligible = localStorage.getItem('OfferCreator')
        if (this.eligible === 'false') {
          this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '/newsfeed', 'OfferCreator')
        }
      }, 3000)
    },
    async saveProjectPrice () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var projid = this.submittedIndustries.length === 1 && this.submittedIndustries[0] === '1062' ? this.parentID : this.projectID
      this.productlist.forEach(p => {
        var industry = p.split('-')[0]
        var jobindustry = p.split('-')[1]
        var prisperindusty = this.productOfferForm[industry + '_' + jobindustry]
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {
          project_id: projid,
          sub_project_id: 0,
          contact_id: this.contactID,
          calculation_id: 0,
          industry_id: industry,
          total: prisperindusty,
          note: this.partnernote,
          job_industry_id: jobindustry,
          signature: this.signaturePng,
          weeks: this.daystofinish,
          days: this.daystofinish,
          start_date: this.datestart,
          offer_id: this.parentofferId,
          parent_offer_id: this.parentofferId,
          reviews_id: this.fiverecommendations,
          job_description: {}
        }
        if (Object.values(this.jobdescarr[industry + '_' + jobindustry].submitted).length > 0) {
          data.job_description = this.jobdescarr[industry + '_' + jobindustry]
        }
        if (this.submittedIndustries.length === 1 && this.submittedIndustries[0] === '1062') {
          data.sub_project_id = this.projectID
        }
        // for (var key in this.productOfferForm[industry]) {
        //   data[key] = this.productOfferForm[industry][key]
        // }
        this.$http.post(this.$bitrixapi + 'partner/wizard/saveListPriceV2', data, { headers }, { emulateJSON: true }).then(
          response => {
            // var res = response.body
            if (industry + '-' + jobindustry === this.productlist[this.productlist.length - 1]) {
              setTimeout(() => {
                let obj = {
                  title: 'Gennemført!',
                  message: '',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
              }, 1000)
              setTimeout(() => {
                this.$router.push('/alle-moeder')
              }, 3000)
            }
          },
          response => {
            var error = response.body.message
            this.$message.error(error)
          })
      })
      // this.saveProjectPriceNonPrimary()
    },
    async saveProjectPricev2 (offerid, jobwithpriceObj) {
      var jobindustry = ''
      var enterpriseId = ''
      var jobwithpriceArr = []
      jobwithpriceArr = jobwithpriceObj.split('_')
      jobindustry = jobwithpriceArr[1]
      enterpriseId = jobwithpriceArr[0]
      var gettotal = this.productOfferForm[jobwithpriceObj]
      setTimeout(() => {
        this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {
          project_id: this.projectID,
          contact_id: this.contactID,
          calculation_id: 0,
          industry_id: enterpriseId,
          total: gettotal,
          note: this.partnernote,
          signature: this.signaturePng,
          weeks: this.daystofinish,
          days: this.daystofinish,
          job_industry_id: jobindustry,
          start_date: this.datestart,
          offer_id: offerid,
          reviews_id: this.fiverecommendations,
          job_description: {}
        }
        if (Object.values(this.jobdescarr[enterpriseId + '_' + jobindustry].submitted).length > 0) {
          data.job_description = this.jobdescarr[enterpriseId + '_' + jobindustry]
        }
        this.$http.post(this.$bitrixapi + 'partner/wizard/saveListPriceV2', data, { headers }, { emulateJSON: true }).then(
          response => {
          // var res = response.body
            if (enterpriseId === this.productlist[this.productlist.length - 1]) {
              setTimeout(() => {
                let obj = {
                  title: 'Gennemført!',
                  message: '',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
              }, 1000)
              setTimeout(() => {
                this.$router.push('/alle-moeder')
              }, 3000)
            }
          },
          response => {
            var error = response.body.message
            this.$message({
              type: 'error',
              message: error
            })
          })
      }, 200)
    },
    saveProjectPricev3 () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      this.productlist.forEach(p => {
        var industry = p.split('-')[0]
        var jobindustry = p.split('-')[1]
        var jobindistryprojectID = this.childprojectObj[Number(jobindustry)]
        var prisperindusty = this.productOfferForm[industry + '_' + jobindustry]
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {
          project_id: this.parentID,
          sub_project_id: jobindistryprojectID,
          contact_id: this.contactID,
          calculation_id: 0,
          industry_id: industry,
          total: prisperindusty,
          note: this.partnernote,
          job_industry_id: jobindustry,
          signature: this.signaturePng,
          weeks: this.daystofinish,
          days: this.daystofinish,
          start_date: this.datestart,
          offer_id: this.parentofferId,
          parent_offer_id: this.parentofferId,
          reviews_id: this.fiverecommendations,
          job_description: {}
        }
        if (Object.values(this.jobdescarr[industry + '_' + jobindustry].submitted).length > 0) {
          data.job_description = this.jobdescarr[industry + '_' + jobindustry]
        }
        this.$http.post(this.$bitrixapi + 'partner/wizard/saveListPriceV2', data, { headers }, { emulateJSON: true }).then(
          response => {
            if (industry + '-' + jobindustry === this.productlist[this.productlist.length - 1]) {
              setTimeout(() => {
                let obj = {
                  title: 'Gennemført!',
                  message: '',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
              }, 1000)
              setTimeout(() => {
                this.$router.push('/alle-moeder')
              }, 3000)
            }
          },
          response => {
            var error = response.body.message
            this.$message.error(error)
          })
      })
    },
    saveProjectPriceNonPrimary () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      this.productlistnotforpartnerArr.forEach(industrynon => {
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {
          project_id: this.projectID,
          contact_id: this.contactID,
          calculation_id: 0,
          industry_id: industrynon.industryid,
          total: 0,
          note: this.partnernote,
          signature: this.signaturePng,
          weeks: this.daystofinish,
          days: this.daystofinish,
          start_date: this.datestart,
          offer_id: this.offerID
        }
        industrynon.industrydetails.forEach(k => {
          data[k.FIELD + '_' + k.ID] = 0
          data[k.ID] = k.DESCRIPTION
        })
        this.$http.post(this.$bitrixapi + 'partner/wizard/saveListPrice', data, { headers }, { emulateJSON: true }).then(
          response => {
          },
          response => {
            var error = response.body.message
            this.$message.error(error)
          })
      })
    },
    updatePriceList () {
      var projid = (this.submittedIndustries.length === 1 && this.submittedIndustries[0] === '1062') || this.contractType === 'Fagentreprise' ? this.parentID : this.projectID
      var jobwithpriceArr = ''
      var enterpriseId = ''
      var jobindustry = ''
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      this.productlist.forEach(industry => {
        jobwithpriceArr = industry.split('-')
        jobindustry = jobwithpriceArr[1]
        enterpriseId = jobwithpriceArr[0]
        var prisperindusty = this.productOfferForm[enterpriseId + '_' + jobindustry]
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {
          project_id: projid,
          contact_id: this.contactID,
          sub_project_id: 0,
          calculation_id: 0,
          industry_id: enterpriseId,
          job_industry_id: jobindustry,
          total: prisperindusty,
          note: this.partnernote,
          signature: this.signaturePng,
          weeks: this.daystofinish,
          days: this.daystofinish,
          start_date: this.datestart,
          reviewsId: this.fiverecommendations,
          job_description: {}
        }
        if (this.submittedIndustries.length === 1 && this.submittedIndustries[0] === '1062') {
          data.sub_project_id = this.projectID
        }
        if (Object.values(this.jobdescarr[enterpriseId + '_' + jobindustry].submitted).length > 0) {
          data.job_description = this.jobdescarr[enterpriseId + '_' + jobindustry]
        }
        // for (var key in this.productOfferForm[industry]) {
        //   var newkey = key.split('_')
        //   data[key] = this.productOfferForm[industry][newkey[1]]
        // }
        this.$http.post(this.$bitrixapi + 'partner/wizard/updateListPricePartner', data, { headers }, { emulateJSON: true }).then(
          response => {
            // var res = response.body
            if (industry === this.productlist[this.productlist.length - 1]) {
              setTimeout(() => {
                let obj = {
                  title: 'Gennemført!',
                  message: '',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
              }, 1000)
              setTimeout(() => {
                this.$router.push('/alle-moeder')
              }, 3000)
            }
          },
          response => {
            this.loading = false
            var error = response.body.message
            this.$message.error(error)
          })
      })
    },
    initiateSignaturepad () {
      setTimeout(() => {
        var canvas = document.querySelector('canvas')
        this.signaturePad = new SignaturePad(canvas, {
          backgroundColor: 'rgb(255, 255, 255)'
        })
      }, 200)
    },
    jobDescRestoreAll (enterpriseid, jobindustryid) {
      this.$confirm('Er du sikker på, at du ikke vil gendanne al tekst tilbage til den oprindelige tekst ?', {
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nej',
        type: 'warning'
      }).then(() => {
        this.editdescfield = true
        var newdesc = []
        Object.values(this.productlistforpricearr[enterpriseid][jobindustryid]['SERIES']).forEach(u => {
          newdesc.push({isediting: false, descr: u, newdesctext: ''})
        })
        this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'] = newdesc
        this.editdescfield = false
      }).catch(() => {
      })
    },
    jobDescEdit (enterpriseid, jobindustryid, indexdesc) {
      this.editdescfield = true
      var text = this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].descr
      this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].isediting = true
      this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].newdesctext = text
      this.editdescfield = false
    },
    jobDescDelete (enterpriseid, jobindustryid, indexdesc) {
      this.$confirm('Er du sikker på, at du vil slette denne beskrivelse?', {
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nej',
        type: 'warning'
      }).then(() => {
        var seirelength = this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'].length
        var seriesempty = this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'].filter(u => {
          return u.descr === ''
        })
        if (parseInt(seirelength - seriesempty.length) <= 1) {
          this.$message({
            type: 'error',
            message: 'Efterlad venligst mindst én tekst'
          })
          return
        }
        // var deletedddesc = {}
        // deletedddesc[indexdesc] = this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].descr
        this.jobdescarr[enterpriseid + '_' + jobindustryid].deleted[indexdesc] = this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].descr
        delete this.jobdescarr[enterpriseid + '_' + jobindustryid].updated[indexdesc]
        delete this.jobdescarr[enterpriseid + '_' + jobindustryid].added[indexdesc]
        this.editdescfield = true
        this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].descr = ''
        this.editdescfield = false
        this.jobdescarr[enterpriseid + '_' + jobindustryid].submitted = []
        this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'].forEach((l) => {
          if (l.descr !== '') {
            this.jobdescarr[enterpriseid + '_' + jobindustryid].submitted.push(l.descr)
          }
        })
      }).catch(() => {
      })
    },
    jobDescCanceledit (enterpriseid, jobindustryid, indexdesc) {
      this.editdescfield = true
      this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].isediting = false
      this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].newdesctext = ''
      if (this.hideplusbutton) {
        this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'].pop()
      }
      this.hideplusbutton = false
      this.editdescfield = false
    },
    jobDescAddandEdit (enterpriseid, jobindustryid, indexdesc) {
      this.editdescfield = true
      var newtext = this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].newdesctext
      if (newtext === '' || this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].descr === 'indtast beskrivelse her') {
        this.$message({
          type: 'error',
          message: 'Tilføj tekst, før du gemmer'
        })
        this.editdescfield = false
        return
      }
      this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].isediting = false
      this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].descr = newtext
      this.jobdescarr[enterpriseid + '_' + jobindustryid].submitted = []
      this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'].forEach((l) => {
        // var changedesc = {}
        // changedesc[index] = l.descr
        if (l.descr !== '') {
          this.jobdescarr[enterpriseid + '_' + jobindustryid].submitted.push(l.descr)
        }
      })
      if (this.hideplusbutton) {
        // var Addedddesc = {}
        // Addedddesc[indexdesc] = newtext
        this.jobdescarr[enterpriseid + '_' + jobindustryid].added[indexdesc] = newtext
        this.hideplusbutton = false
      } else {
        // var updateddesc = {}
        // updateddesc[indexdesc] = newtext
        this.jobdescarr[enterpriseid + '_' + jobindustryid].updated[indexdesc] = newtext
      }
      this.editdescfield = false
    },
    jobDescAddlineDesc (enterpriseid, jobindustryid) {
      this.editdescfield = true
      this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'].push({isediting: true, desc: 'indtast beskrivelse her', newdesctext: ''})
      this.hideplusbutton = true
      this.editdescfield = false
    },
    getinsuranceamount () {
      this.haaid = localStorage.getItem('haaid')
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'integration/getInsuranceSettings', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.insurancetype = (!res.insurance_price_in_dkk !== '' && !res.insurance_price_in_dkk !== null) ? 'amount' : 'percentage'
          this.insuranceamount = res.insurance_price_in_dkk
          this.insurancepercentage = res.insurance_price_percentage
        },
        response => {
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    getenterprise () {
      this.$http.get(this.$bitrixapi + 'supplier/getSupplierInfo/' + this.haaid, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var enterpriseid = Number(res.data.UF_CRM_COMPANY_ENTERPRISE)
            this.partnerenterprise = enterpriseid === 1 ? 'Hovedentreprise' : enterpriseid === 3 ? 'Hovedentreprise' : 'Fagentreprise'
          }
          this.getallwizardproduct()
        },
        (response) => {
          this.getallwizardproduct()
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    getProductList () {
      this.loading = true
      var thisvar = this
      this.haaid = localStorage.getItem('haaid')
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPrice?project_id=' + (this.offerType === 'invitation' ? this.projectID : this.parentID) + '&contact_id=' + this.contactID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.productlist = []
          for (var index in res) {
            var indexindustry = res[index]['WIZARD_ID']
            this.industrypris[index] = 0
            if (((this.productrelatedbyPartnerPrimaryIndusty.includes(index) || res[index]['PARTNER_IDS'].includes(this.haaid)) && this.industryID.includes(index)) || this.offerType === 'invitation') {
              this.productlistforpricearr.push({'industryid': index, 'industrydetails': res[index]['INDUSTRY'], 'wizardId': indexindustry})
              thisvar.productlist.push(index)
              thisvar.industrypris[index] = 0
              thisvar.productOfferForm[index] = {}
              thisvar.productOfferFormRules[index] = {}
            } else {
              if (this.industryID === index) {
                this.productlistnotforpartnerArr.push({'industryid': index, 'industrydetails': res[index]['INDUSTRY'], 'wizardId': indexindustry})
              }
            }
          }
          this.productlistforpricearr.forEach(y => {
            y.industrydetails.forEach(o => {
              thisvar.productOfferForm[y.industryid][o.FIELD + '_' + o.ID] = ''
              thisvar.productOfferFormEdit[o.ID] = o.FIELD + '_' + o.ID
              thisvar.createrules(o.FIELD, o.ID, y.industryid)
            })
          })
          if (this.$route.query.offerID) {
            this.offerID = this.$route.query.offerID
            this.getAcceptedOfferPrice()
          }
          this.loading = false
        },
        response => {
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        })
    },
    getProductListAi () {
      this.loading = true
      var thisvar = this
      this.haaid = localStorage.getItem('haaid')
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPricePartnerAi?project_id=' + this.projectID + '&contact_id=' + this.contactID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.productlist = []
          for (var index in res) {
            var enterpiserdata = {}
            enterpiserdata['industryid'] = index
            enterpiserdata['industrydetails'] = {}
            thisvar.productlist.push(index)
            for (var jobindustry in res[index]) {
              enterpiserdata['jobindustry'] = jobindustry
              enterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry]
            }
            if ((this.productrelatedbyPartnerPrimaryIndusty.includes(enterpiserdata['jobindustry'])) || this.offerType === 'invitation') {
              this.productlistforpricearr.push(enterpiserdata)
            } else {
              this.productlistnotforpartnerArr.push(enterpiserdata)
            }
          }
          this.productlistforpricearr.forEach(y => {
            Object.entries(y.industrydetails).forEach(o => {
              thisvar.industrypris[y.industryid + '_' + o[0]] = 0
              thisvar.productOfferForm[y.industryid + '_' + o[0]] = 0
              thisvar.createrules(y.industryid + '_' + o[0])
            })
          })
          // if (this.$route.query.offerID) {
          //   this.offerID = this.$route.query.offerID
          //   this.getAcceptedOfferPrice()
          // }
          this.loading = false
        },
        response => {
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        })
    },
    getProductListAiV2 () {
      var prodid = this.contractType === 'Hovedentreprise' ? this.$route.query.projectID : this.$route.query.parentID
      this.loading = true
      var thisvar = this
      this.haaid = localStorage.getItem('haaid')
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPricePartnerAiV2?project_id=' + prodid + '&contact_id=' + this.contactID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.productlist = []
          var productlistforpricearr = {}
          var productlistnotforpartnerArr = {}
          res.forEach((subproject, index) => {
            if (!this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) {
              return true
            }
            var enterpiserdata = {}
            enterpiserdata['industryid'] = subproject.INDUSTRY
            enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY
            enterpiserdata['wizardId'] = subproject.ID
            enterpiserdata['subprojectId'] = this.childprojectObj[subproject.JOB_INDUSTRY]
            enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : ''
            enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : ''
            enterpiserdata['industrydetails'] = {}
            if (!productlistforpricearr[subproject.INDUSTRY]) {
              if ((this.productrelatedbyPartnerPrimaryIndusty.includes(subproject.JOB_INDUSTRY) || (this.submittedIndustries.includes(this.productrelatedbyPartnerPrimaryIndusty[0]) && this.contractType === 'Hovedentreprise') || enterpiserdata.partnerIDS.includes(this.haaid) || (enterpiserdata.originalpartnerIDS.includes(this.haaid) && this.contractType === 'Hovedentreprise') || (this.offerType === 'invitation' && this.submittedIndustries.includes(Number(subproject.JOB_INDUSTRY)))) && Number(subproject.JOB_INDUSTRY) !== 1062) {
                enterpiserdata['SERIES'] = subproject.SERIES
                thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY)
                productlistforpricearr[subproject.INDUSTRY] = {}
                productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
              }
            } else {
              if ((this.productrelatedbyPartnerPrimaryIndusty.includes(subproject.JOB_INDUSTRY) || (this.submittedIndustries.includes(this.productrelatedbyPartnerPrimaryIndusty[0]) && this.contractType === 'Hovedentreprise') || enterpiserdata.partnerIDS.includes(this.haaid) || (enterpiserdata.originalpartnerIDS.includes(this.haaid) && this.contractType === 'Hovedentreprise') || (this.offerType === 'invitation' && this.submittedIndustries.includes(Number(subproject.JOB_INDUSTRY)))) && Number(subproject.JOB_INDUSTRY) !== 1062) {
                thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY)
                enterpiserdata['SERIES'] = subproject.SERIES
                productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
              }
            }
          })
          if (this.contractType === 'Fagentreprise') {
            // (this.childprojectObj[Number(this.productrelatedbyPartnerPrimaryIndusty[0])] !== 'undefined' && this.childprojectObj[Number(this.productrelatedbyPartnerPrimaryIndusty[0])] !== null && this.contractType === 'Hovedentreprise')
            res.forEach((subproject, index) => {
              if (this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) {
                var enterpiserdata = {}
                enterpiserdata['industryid'] = subproject.INDUSTRY
                enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY
                enterpiserdata['wizardId'] = subproject.ID
                enterpiserdata['subprojectId'] = this.childprojectObj[subproject.JOB_INDUSTRY]
                enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : ''
                enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : ''
                enterpiserdata['industrydetails'] = {}
                if (!productlistnotforpartnerArr[subproject.INDUSTRY]) {
                  if ((this.productrelatedbyPartnerPrimaryIndusty.includes(subproject.JOB_INDUSTRY) || (this.submittedIndustries.includes(this.productrelatedbyPartnerPrimaryIndusty[0]) && this.contractType === 'Hovedentreprise') || enterpiserdata.partnerIDS.includes(this.haaid) || (enterpiserdata.originalpartnerIDS.includes(this.haaid) && this.contractType === 'Hovedentreprise') || (this.offerType === 'invitation' && this.submittedIndustries.includes(Number(subproject.JOB_INDUSTRY)))) && Number(subproject.JOB_INDUSTRY) !== 1062) {
                  } else {
                    productlistnotforpartnerArr[subproject.INDUSTRY] = {}
                    productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
                  }
                } else {
                  if ((this.productrelatedbyPartnerPrimaryIndusty.includes(subproject.JOB_INDUSTRY) || (this.submittedIndustries.includes(this.productrelatedbyPartnerPrimaryIndusty[0]) && this.contractType === 'Hovedentreprise') || enterpiserdata.partnerIDS.includes(this.haaid) || (enterpiserdata.originalpartnerIDS.includes(this.haaid) && this.contractType === 'Hovedentreprise') || (this.offerType === 'invitation' && this.submittedIndustries.includes(Number(subproject.JOB_INDUSTRY)))) && Number(subproject.JOB_INDUSTRY) !== 1062) {
                  } else {
                    productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
                  }
                }
              }
            })
          } else {
            var enterpiserdata = {}
            enterpiserdata['industryid'] = this.projectTitle
            enterpiserdata['jobindustry'] = res[0].JOB_INDUSTRY
            enterpiserdata['wizardId'] = res[0].ID
            enterpiserdata['subprojectId'] = res[0].PROJECT_ID
            enterpiserdata['partnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : ''
            enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : ''
            enterpiserdata['industrydetails'] = {}
            if (this.productrelatedbyPartnerPrimaryIndusty.includes(res[0].JOB_INDUSTRY) || (this.submittedIndustries.includes(this.productrelatedbyPartnerPrimaryIndusty[0]) && this.contractType === 'Hovedentreprise') || enterpiserdata.partnerIDS.includes(this.haaid) || (enterpiserdata.originalpartnerIDS.includes(this.haaid) && this.contractType === 'Hovedentreprise') || (this.offerType === 'invitation' && this.submittedIndustries.includes(Number(res[0].JOB_INDUSTRY)))) {
            } else {
              productlistnotforpartnerArr[res[0].JOB_INDUSTRY] = {}
              productlistnotforpartnerArr[res[0].JOB_INDUSTRY] = enterpiserdata
            }
          }
          this.productlistforpricearr = productlistforpricearr
          this.productlistnotforpartnerArr = productlistnotforpartnerArr
          Object.entries(this.productlistforpricearr).forEach(y => {
            Object.entries(y[1]).forEach(o => {
              thisvar.industrypris[y[0] + '_' + o[0]] = 0
              thisvar.productOfferForm[y[0] + '_' + o[0]] = 0
              thisvar.createrules(y[0] + '_' + o[0])
            })
          })
          if (this.$route.query.offerID) {
            this.offerID = this.$route.query.offerID
            this.getAcceptedOfferPrice()
          }
          this.loading = false
        },
        response => {
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        })
    },
    getProductListAiV3 () {
      var prodid = this.contractType === 'Hovedentreprise' ? this.$route.query.projectID : this.$route.query.parentID
      this.loading = true
      var thisvar = this
      this.haaid = localStorage.getItem('haaid')
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPricePartnerAiV2?project_id=' + prodid + '&contact_id=' + this.contactID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.productlist = []
          var productlistforpricearr = {}
          var productlistnotforpartnerArr = {}
          res.forEach((subproject, index) => {
            if (!this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) {
              return true
            }
            var enterpiserdata = {}
            enterpiserdata['industryid'] = subproject.INDUSTRY
            enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY
            enterpiserdata['wizardId'] = subproject.ID
            enterpiserdata['subprojectId'] = this.childprojectObj[subproject.JOB_INDUSTRY]
            enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : ''
            enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : ''
            enterpiserdata['industrydetails'] = {}
            if (!productlistforpricearr[subproject.INDUSTRY]) {
              if ((this.productrelatedbyPartnerPrimaryIndusty.includes(subproject.JOB_INDUSTRY) || this.partnerenterprise === 'Hovedentreprise' || enterpiserdata.partnerIDS.includes(this.haaid) || (enterpiserdata.originalpartnerIDS.includes(this.haaid) && this.contractType === 'Hovedentreprise') || (this.offerType === 'invitation' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062) {
                enterpiserdata['SERIES'] = subproject.SERIES
                thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY)
                productlistforpricearr[subproject.INDUSTRY] = {}
                productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
              }
            } else {
              if ((this.productrelatedbyPartnerPrimaryIndusty.includes(subproject.JOB_INDUSTRY) || this.partnerenterprise === 'Hovedentreprise' || enterpiserdata.partnerIDS.includes(this.haaid) || (enterpiserdata.originalpartnerIDS.includes(this.haaid) && this.contractType === 'Hovedentreprise') || (this.offerType === 'invitation' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062) {
                thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY)
                enterpiserdata['SERIES'] = subproject.SERIES
                productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
              }
            }
          })
          if (this.contractType === 'Fagentreprise') {
            // (this.childprojectObj[Number(this.productrelatedbyPartnerPrimaryIndusty[0])] !== 'undefined' && this.childprojectObj[Number(this.productrelatedbyPartnerPrimaryIndusty[0])] !== null && this.contractType === 'Hovedentreprise')
            res.forEach((subproject, index) => {
              if (this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) {
                var enterpiserdata = {}
                enterpiserdata['industryid'] = subproject.INDUSTRY
                enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY
                enterpiserdata['wizardId'] = subproject.ID
                enterpiserdata['subprojectId'] = this.childprojectObj[subproject.JOB_INDUSTRY]
                enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : ''
                enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : ''
                enterpiserdata['industrydetails'] = {}
                if (!productlistnotforpartnerArr[subproject.INDUSTRY]) {
                  if ((this.productrelatedbyPartnerPrimaryIndusty.includes(subproject.JOB_INDUSTRY) || this.partnerenterprise === 'Hovedentreprise' || enterpiserdata.partnerIDS.includes(this.haaid) || (enterpiserdata.originalpartnerIDS.includes(this.haaid) && this.contractType === 'Hovedentreprise') || (this.offerType === 'invitation' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062) {
                  } else {
                    productlistnotforpartnerArr[subproject.INDUSTRY] = {}
                    productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
                  }
                } else {
                  if ((this.productrelatedbyPartnerPrimaryIndusty.includes(subproject.JOB_INDUSTRY) || this.partnerenterprise === 'Hovedentreprise' || enterpiserdata.partnerIDS.includes(this.haaid) || (enterpiserdata.originalpartnerIDS.includes(this.haaid) && this.contractType === 'Hovedentreprise') || (this.offerType === 'invitation' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062) {
                  } else {
                    productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
                  }
                }
              }
            })
          } else {
            var enterpiserdata = {}
            enterpiserdata['industryid'] = this.projectTitle
            enterpiserdata['jobindustry'] = res[0].JOB_INDUSTRY
            enterpiserdata['wizardId'] = res[0].ID
            enterpiserdata['subprojectId'] = res[0].PROJECT_ID
            enterpiserdata['partnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : ''
            enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : ''
            enterpiserdata['industrydetails'] = {}
            if (this.productrelatedbyPartnerPrimaryIndusty.includes(res[0].JOB_INDUSTRY) || this.partnerenterprise === 'Hovedentreprise' || enterpiserdata.partnerIDS.includes(this.haaid) || (enterpiserdata.originalpartnerIDS.includes(this.haaid) && this.contractType === 'Hovedentreprise') || (this.offerType === 'invitation' && this.submittedIndustries.includes(Number(res[0].JOB_INDUSTRY)))) {
            } else {
              productlistnotforpartnerArr[res[0].JOB_INDUSTRY] = {}
              productlistnotforpartnerArr[res[0].JOB_INDUSTRY] = enterpiserdata
            }
          }
          this.productlistforpricearr = productlistforpricearr
          this.productlistnotforpartnerArr = productlistnotforpartnerArr
          Object.entries(this.productlistforpricearr).forEach(y => {
            Object.entries(y[1]).forEach(o => {
              thisvar.industrypris[y[0] + '_' + o[0]] = 0
              thisvar.productOfferForm[y[0] + '_' + o[0]] = 0
              thisvar.createrules(y[0] + '_' + o[0])
            })
          })
          if (this.$route.query.offerID) {
            this.offerID = this.$route.query.offerID
            this.getAcceptedOfferPrice()
          }
          this.loading = false
        },
        response => {
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        })
    },
    getProductListAiV4 () {
      var prodid = this.contractType === 'Hovedentreprise' ? this.submittedIndustries.length === 1 && Number(this.submittedIndustries[0]) === 1062 ? this.parentID : this.$route.query.projectID : this.parentID
      this.loading = true
      var thisvar = this
      this.haaid = localStorage.getItem('haaid')
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPricePartnerAiV2?project_id=' + prodid + '&contact_id=' + this.contactID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.productlist = []
          var productlistforpricearr = {}
          var productlistnotforpartnerArr = {}
          res.forEach((subproject, index) => {
            var enterpiserdata = {}
            enterpiserdata['industryid'] = subproject.INDUSTRY
            enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY
            enterpiserdata['wizardId'] = subproject.ID
            enterpiserdata['subprojectId'] = this.childprojectObj[subproject.JOB_INDUSTRY]
            enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : ''
            enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : ''
            enterpiserdata['industrydetails'] = {}
            if (!productlistforpricearr[subproject.INDUSTRY]) {
              if ((((this.partnerenterprise === 'Hovedentreprise' && this.contractType !== 'Fagentreprise') || enterpiserdata.partnerIDS.includes(this.haaid) || (this.offerType === 'invitation' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) || (this.contractType === 'Fagentreprise' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062 && this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) || (this.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(this.submittedIndustries[0]) && this.contractType === 'Fagentreprise')) {
                enterpiserdata['SERIES'] = subproject.SERIES
                thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY)
                productlistforpricearr[subproject.INDUSTRY] = {}
                productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
              } else if ((this.partnerenterprise === 'Hovedentreprise' && this.contractType === 'Hovedentreprise' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY) && Number(subproject.JOB_INDUSTRY) === 1062 && this.submittedIndustries.length === 1)) {
                enterpiserdata['SERIES'] = subproject.SERIES
                thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY)
                productlistforpricearr[subproject.INDUSTRY] = {}
                productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
              }
            } else {
              if ((((this.partnerenterprise === 'Hovedentreprise' && this.contractType !== 'Fagentreprise') || enterpiserdata.partnerIDS.includes(this.haaid) || (this.offerType === 'invitation' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) || (this.contractType === 'Fagentreprise' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062 && this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) || (this.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(this.submittedIndustries[0]) && this.contractType === 'Fagentreprise')) {
                thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY)
                enterpiserdata['SERIES'] = subproject.SERIES
                productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
              }
            }
          })
          if (this.contractType === 'Fagentreprise') {
            // (this.childprojectObj[Number(this.productrelatedbyPartnerPrimaryIndusty[0])] !== 'undefined' && this.childprojectObj[Number(this.productrelatedbyPartnerPrimaryIndusty[0])] !== null && this.contractType === 'Hovedentreprise')
            res.forEach((subproject, index) => {
              var enterpiserdata = {}
              enterpiserdata['industryid'] = subproject.INDUSTRY
              enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY
              enterpiserdata['wizardId'] = subproject.ID
              enterpiserdata['subprojectId'] = this.childprojectObj[subproject.JOB_INDUSTRY]
              enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : ''
              enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : ''
              enterpiserdata['industrydetails'] = {}
              if (!productlistnotforpartnerArr[subproject.INDUSTRY]) {
                if ((((this.partnerenterprise === 'Hovedentreprise' && this.contractType !== 'Fagentreprise') || enterpiserdata.partnerIDS.includes(this.haaid) || (this.offerType === 'invitation' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) || (this.contractType === 'Fagentreprise' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062) || (this.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(this.submittedIndustries[0]) && this.contractType === 'Fagentreprise')) {
                } else {
                  if (this.submittedIndustries.length === 1 && Number(this.submittedIndustries[0]) === 1062) {
                  } else {
                    productlistnotforpartnerArr[subproject.INDUSTRY] = {}
                    productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
                  }
                }
              } else {
                if ((((this.partnerenterprise === 'Hovedentreprise' && this.contractType !== 'Fagentreprise') || enterpiserdata.partnerIDS.includes(this.haaid) || (this.offerType === 'invitation' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) || (this.contractType === 'Fagentreprise' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062) || (this.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(this.submittedIndustries[0]) && this.contractType === 'Fagentreprise')) {
                } else {
                  if (this.submittedIndustries.length === 1 && Number(this.submittedIndustries[0]) === 1062) {
                  } else {
                    productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
                  }
                }
              }
            })
          }
          this.productlistforpricearr = productlistforpricearr
          this.productlistnotforpartnerArr = productlistnotforpartnerArr
          Object.entries(this.productlistforpricearr).forEach(y => {
            Object.entries(y[1]).forEach(o => {
              var newdesc = []
              o[1].SERIES.forEach(p => {
                newdesc.push({isediting: false, descr: p, newdesctext: ''})
              })
              o[1].SERIESARR = newdesc
              thisvar.industrypris[y[0] + '_' + o[0]] = 0
              thisvar.productOfferForm[y[0] + '_' + o[0]] = 0
              thisvar.jobdescarr[y[0] + '_' + o[0]] = {
                submitted: {},
                updated: {},
                added: {},
                deleted: {}
              }
              thisvar.createrules(y[0] + '_' + o[0])
            })
          })
          this.loading = false
        },
        response => {
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        })
    },
    // with request feature for hoved and remove the partner enterprise checker
    getProductListAiV5 () {
      var prodid = this.contractType === 'Hovedentreprise' ? this.submittedIndustries.length === 1 && Number(this.submittedIndustries[0]) === 1062 ? this.parentID : this.$route.query.projectID : this.parentID
      this.loading = true
      var thisvar = this
      this.haaid = localStorage.getItem('haaid')
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPricePartnerAiV2?project_id=' + prodid + '&contact_id=' + this.contactID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.productlist = []
          var productlistforpricearr = {}
          var productlistnotforpartnerArr = {}
          res.forEach((subproject, index) => {
            var enterpiserdata = {}
            enterpiserdata['industryid'] = subproject.INDUSTRY
            enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY
            enterpiserdata['wizardId'] = subproject.ID
            enterpiserdata['subprojectId'] = this.childprojectObj[subproject.JOB_INDUSTRY]
            enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : ''
            enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : ''
            enterpiserdata['industrydetails'] = {}
            if (!productlistforpricearr[subproject.INDUSTRY]) {
              if ((((this.contractType !== 'Fagentreprise') || enterpiserdata.partnerIDS.includes(this.haaid) || (this.offerType === 'invitation' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) || (this.contractType === 'Fagentreprise' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062 && this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) || (this.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(this.submittedIndustries[0]) && this.contractType === 'Fagentreprise')) {
                enterpiserdata['SERIES'] = subproject.SERIES
                thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY)
                productlistforpricearr[subproject.INDUSTRY] = {}
                productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
              } else if ((this.partnerenterprise === 'Hovedentreprise' && this.contractType === 'Hovedentreprise' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY) && Number(subproject.JOB_INDUSTRY) === 1062 && this.submittedIndustries.length === 1)) {
                enterpiserdata['SERIES'] = subproject.SERIES
                thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY)
                productlistforpricearr[subproject.INDUSTRY] = {}
                productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
              }
            } else {
              if ((((this.contractType !== 'Fagentreprise') || enterpiserdata.partnerIDS.includes(this.haaid) || (this.offerType === 'invitation' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) || (this.contractType === 'Fagentreprise' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062 && this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) || (this.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(this.submittedIndustries[0]) && this.contractType === 'Fagentreprise')) {
                thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY)
                enterpiserdata['SERIES'] = subproject.SERIES
                productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
              }
            }
          })
          if (this.contractType === 'Fagentreprise') {
            // (this.childprojectObj[Number(this.productrelatedbyPartnerPrimaryIndusty[0])] !== 'undefined' && this.childprojectObj[Number(this.productrelatedbyPartnerPrimaryIndusty[0])] !== null && this.contractType === 'Hovedentreprise')
            res.forEach((subproject, index) => {
              var enterpiserdata = {}
              enterpiserdata['industryid'] = subproject.INDUSTRY
              enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY
              enterpiserdata['wizardId'] = subproject.ID
              enterpiserdata['subprojectId'] = this.childprojectObj[subproject.JOB_INDUSTRY]
              enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : ''
              enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : ''
              enterpiserdata['industrydetails'] = {}
              if (!productlistnotforpartnerArr[subproject.INDUSTRY]) {
                if ((((this.contractType !== 'Fagentreprise') || enterpiserdata.partnerIDS.includes(this.haaid) || (this.offerType === 'invitation' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) || (this.contractType === 'Fagentreprise' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062) || (this.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(this.submittedIndustries[0]) && this.contractType === 'Fagentreprise')) {
                } else {
                  if (this.submittedIndustries.length === 1 && Number(this.submittedIndustries[0]) === 1062) {
                  } else {
                    productlistnotforpartnerArr[subproject.INDUSTRY] = {}
                    productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
                  }
                }
              } else {
                if ((((this.contractType !== 'Fagentreprise') || enterpiserdata.partnerIDS.includes(this.haaid) || (this.offerType === 'invitation' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) || (this.contractType === 'Fagentreprise' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062) || (this.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(this.submittedIndustries[0]) && this.contractType === 'Fagentreprise')) {
                } else {
                  if (this.submittedIndustries.length === 1 && Number(this.submittedIndustries[0]) === 1062) {
                  } else {
                    productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
                  }
                }
              }
            })
          } else {
            res.forEach((subproject, index) => {
              var enterpiserdata = {}
              enterpiserdata['industryid'] = subproject.INDUSTRY
              enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY
              enterpiserdata['wizardId'] = subproject.ID
              enterpiserdata['subprojectId'] = this.childprojectObj[subproject.JOB_INDUSTRY]
              enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : ''
              enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : ''
              enterpiserdata['industrydetails'] = {}
              if (!productlistnotforpartnerArr[subproject.INDUSTRY]) {
                if ((((this.contractType !== 'Fagentreprise') || enterpiserdata.partnerIDS.includes(this.haaid) || (this.offerType === 'invitation' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) || (this.contractType === 'Fagentreprise' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062 && this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) || (this.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(this.submittedIndustries[0]) && this.contractType === 'Fagentreprise')) {
                } else {
                  if (this.submittedIndustries.length === 1 && Number(this.submittedIndustries[0]) === 1062) {
                  } else {
                    productlistnotforpartnerArr[subproject.INDUSTRY] = {}
                    productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
                  }
                }
              } else {
                if ((((this.contractType !== 'Fagentreprise') || enterpiserdata.partnerIDS.includes(this.haaid) || (this.offerType === 'invitation' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) || (this.contractType === 'Fagentreprise' && this.submittedIndustries.includes(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062 && this.submittedIndustries.includes(subproject.JOB_INDUSTRY)) || (this.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(this.submittedIndustries[0]) && this.contractType === 'Fagentreprise')) {
                } else {
                  if (this.submittedIndustries.length === 1 && Number(this.submittedIndustries[0]) === 1062) {
                  } else {
                    productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata
                  }
                }
              }
            })
          }
          this.productlistforpricearr = productlistforpricearr
          this.productlistnotforpartnerArr = productlistnotforpartnerArr
          Object.entries(this.productlistforpricearr).forEach(y => {
            Object.entries(y[1]).forEach(o => {
              if (o[1].SERIES) {
                var newdesc = []
                o[1].SERIES.forEach(p => {
                  newdesc.push({isediting: false, descr: p, newdesctext: ''})
                })
                o[1].SERIESARR = newdesc
                thisvar.industrypris[y[0] + '_' + o[0]] = 0
                thisvar.productOfferForm[y[0] + '_' + o[0]] = 0
                thisvar.jobdescarr[y[0] + '_' + o[0]] = {
                  submitted: {},
                  updated: {},
                  added: {},
                  deleted: {}
                }
                thisvar.createrules(y[0] + '_' + o[0])
              }
            })
          })
          this.loading = false
        },
        response => {
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        })
    },
    getsubprojectid (jobindustryid) {
      this.childprojects.forEach(p => {
        if (p.JOB_INDUSTRY === Number(jobindustryid)) {
          return p.ID
        }
      })
      return ''
    },
    gettaskbitrix () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      this.haaId = localStorage.getItem('haaid')
      this.$http.get(this.$bitrixapi + 'industries/full/', {headers}, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var industryname = {}
            res.data.forEach(l => {
              industryname[l.BRANCHE_ID] = l.BRANCHE
            })
            this.itemsjobindustry = industryname
          }
        },
        (response) => {
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    getBranchenamebyCode (code) {
      var branchename = []
      branchename = this.mainwizarproductarr.filter(p => {
        return p.producttypeid === code
      })
      if (branchename.length < 1) {
        return ''
      }
      return branchename[0]['producttype']
    },
    getallwizardproduct () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListIndustry', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.mainwizarproductarr = res
          if (this.$route.query.offerID) {
            this.offerID = this.$route.query.offerID
            this.getAcceptedOfferPricev2()
          } else {
            this.getProductListAiV5()
          }
        },
        err => {
          var error = err.body.message
          this.$message({
            type: 'error',
            message: error
          })
        })
    },
    getallwizardproduct_old () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
      }
      this.$http.get(this.$bitrixapi + 'partner/wizard/all', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.mainwizarproductarr = res
          var productrelatedbyPartnerPrimaryIndustys = []
          res.forEach(n => {
            if (n.industry === this.partnerprimaryindustry) {
              productrelatedbyPartnerPrimaryIndustys.push(n.industry)
            }
          })
          // to add other primary industry for test
          // productrelatedbyPartnerPrimaryIndustys.push('10')
          // productrelatedbyPartnerPrimaryIndustys.push('1061')
          this.productrelatedbyPartnerPrimaryIndusty = productrelatedbyPartnerPrimaryIndustys
          if (this.$route.query.offerID) {
            this.offerID = this.$route.query.offerID
            this.getAcceptedOfferPricev2()
          } else {
            this.getProductListAiV5()
          }
        },
        err => {
          var error = err.body.message
          this.$message({
            type: 'error',
            message: error
          })
        })
    },
    getAcceptedOfferPrice (calculationid = 0) {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPriceMinbolig?project_id=' + this.projectID + '&contact_id=' + this.contactID + '&calculation_id=' + calculationid, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          var result = []
          res.result.forEach(l => {
            if (l.PARTNER_ID === this.haaid && l.OFFER_ID === this.offerID) {
              for (var key in l.SERIES) {
                this.productOfferPerForm[this.productOfferFormEdit[key]] = l.SERIES[key]
              }
              this.daystofinish = l.WEEKS
              this.datestart = l.START_DATE
              result.push(l)
            }
          })
          this.editPriceArr = result
        },
        response => {
          this.loading = false
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    getAcceptedOfferPricev2 (calculationid = 0) {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var projid = (this.submittedIndustries.length === 1 && this.submittedIndustries[0] === '1062') || this.contractType === 'Fagentreprise' ? this.parentID : this.projectID
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPriceMinboligV2?project_id=' + projid + '&contact_id=' + this.contactID + '&calculation_id=' + calculationid, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          var result = []
          var productlistforpricearr = {}
          res.result.forEach(l => {
            if (l.PARTNER_ID === this.haaid && l.OFFER_ID === this.offerID) {
              var enterpiserdata = {}
              enterpiserdata['industryid'] = l.INDUSTRY
              enterpiserdata['jobindustry'] = l.JOB_INDUSTRY
              enterpiserdata['wizardId'] = 0
              enterpiserdata['subprojectId'] = this.childprojectObj[l.JOB_INDUSTRY]
              enterpiserdata['partnerIDS'] = l.PARTNER_IDS ? l.PARTNER_IDS : ''
              // enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : ''
              enterpiserdata['industrydetails'] = {}
              enterpiserdata['pris'] = l.TOTAL
              if (!productlistforpricearr[l.INDUSTRY]) {
                if (l.SERIES !== null) {
                  enterpiserdata['SERIES'] = l.SERIES
                } else {
                  enterpiserdata['SERIES'] = l.SERIES_ORIGINAL
                }
                this.productlist.push(l.INDUSTRY + '-' + l.JOB_INDUSTRY)
                productlistforpricearr[l.INDUSTRY] = {}
                productlistforpricearr[l.INDUSTRY][l.JOB_INDUSTRY] = enterpiserdata
              } else {
                this.productlist.push(l.INDUSTRY + '-' + l.JOB_INDUSTRY)
                if (l.SERIES !== null) {
                  enterpiserdata['SERIES'] = l.SERIES
                } else {
                  enterpiserdata['SERIES'] = l.SERIES_ORIGINAL
                }
                productlistforpricearr[l.INDUSTRY][l.JOB_INDUSTRY] = enterpiserdata
              }
              this.daystofinish = l.WEEKS
              this.datestart = l.START_DATE
              this.partnernote = l.NOTE
              this.fiverecommendations = l.REVIEWS_ID
              this.total += Number(l.TOTAL)
              result.push(l)
            }
          })
          this.productlistforpricearr = productlistforpricearr
          Object.entries(this.productlistforpricearr).forEach(y => {
            Object.entries(y[1]).forEach(o => {
              var newdesc = []
              if (o[1].SERIES !== null) {
                Object.values(o[1].SERIES).forEach(p => {
                  newdesc.push({isediting: false, descr: p, newdesctext: ''})
                })
              } else {
                o[1].SERIES_ORIGINAL.forEach(p => {
                  newdesc.push({isediting: false, descr: p, newdesctext: ''})
                })
              }
              o[1].SERIESARR = newdesc
              this.industrypris[y[0] + '_' + o[0]] = Number(o[1].pris)
              this.productOfferForm[y[0] + '_' + o[0]] = Number(o[1].pris)
              this.jobdescarr[y[0] + '_' + o[0]] = {
                submitted: {},
                updated: {},
                added: {},
                deleted: {}
              }
              this.createrules(y[0] + '_' + o[0])
            })
          })
          this.loading = false
        },
        response => {
          this.loading = false
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    getallrecommendations () {
      var salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'anbefalinger', salesPerson: salesPerson, levid: this.haaid}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.allrecommendatationsitems = res
            var toprecords = []
            var topfiverecords = []
            toprecords = this.allrecommendatationsitems.filter((item) => {
              return item.Rating > 3.9
            })
            toprecords.sort(function (a, b) { return a - b })
            topfiverecords = toprecords.slice(0, 5)
            // topfiverecords.forEach(function (item, index) {
            //   this.assignfiverecommendations(item)
            // })
            this.fiverecommendations = topfiverecords.map((item, index) => {
              return item.ReviewId
            })
          },
          response => {
            this.loading = false
            this.$message({
              type: 'error',
              message: response.body.message
            })
          })
    },
    checkifselected (item) {
      if (this.fiverecommendations.includes(item)) {
        return true
      } else {
        return false
      }
    },
    assignfiverecommendations (item) {
      this.fiverecommendations.push(item)
      if (this.fiverecommendations.includes(item)) {
        document.querySelector('div#box' + item).classList.add('reviewbox')
      }
      if (this.fiverecommendations.length === 5) {
        // document.querySelectorAll('#addthisreview').classlist.add('no-events')
        // document.querySelector('button#addthisreview' + item).disabled = true
      }
    },
    removethisrecommendation (item) {
      let idx = this.fiverecommendations.indexOf(item)
      if (idx > -1) {
        this.fiverecommendations.splice(idx, 1)
      }
      document.querySelector('div#box' + item).classList.remove('reviewbox')
    },
    createrules (field) {
      this.productOfferFormRules[field] = []
      var fieldrule = {}
      var errormessage = 'sæt venligst nummer'
      fieldrule = {
        // required: true,
        type: 'number',
        min: 1,
        max: 99999999999,
        message: errormessage,
        trigger: 'blur'
      }
      this.productOfferFormRules[field].push(fieldrule)
    },
    computetotal_old (price, id, text, industryid, fieldindex, formindex) {
      var error = 0
      this.$refs['productOfferForm'].validate((valid) => {
        if (!valid) {
          error = 1
        }
      })
      if (error === 1) {
        return false
      }
      this.productOfferForm[industryid][id] = text
      this.productOfferForm[industryid][fieldindex] = price
      // // console.log('Object.values(this.productOfferForm[industryid])', Object.values(this.productOfferForm[industryid]))
      // const sum = this.productOfferForm[industryid].reduce((accumulator, object) => {
      //   if (key.includes('_') && this.productOfferForm[industryid] !== '') {
      //     return accumulator + object.salary
      //   }
      // }, 0)
      this.industrypris[industryid] = 0
      for (var key in this.productOfferForm[industryid]) {
        if (key.includes('_') && this.productOfferForm[industryid] !== '') {
          this.industrypris[industryid] = parseInt(this.industrypris[industryid] + this.productOfferForm[industryid][key])
        }
      }
      this.total = 0
      var totalvalue = document.querySelectorAll('[role="spinbutton"]')
      totalvalue.forEach(p => {
        this.total += p.value !== '' ? Number(p.value) : 0
      })
    },
    computetotal (price, priceindex) {
      var error = 0
      this.$refs['productOfferForm'].validate((valid) => {
        if (!valid) {
          error = 1
        }
      })
      if (error === 1) {
        return false
      }
      // this.industrypris[priceindex] = 0
      // for (var key in this.productOfferForm) {
      //   this.industrypris[priceindex] = parseInt(this.industrypris[priceindex] + this.productOfferForm[key])
      // }
      this.total = 0
      var totalvalue = document.querySelectorAll('[role="spinbutton"]')
      totalvalue.forEach(p => {
        this.total += p.value !== '' ? Number(p.value) : 0
      })
    },
    closesignature () {
      this.$refs['signaturepopup'].hide()
    },
    opentermpopup () {
      if (this.termslink === null) {
        this.TermsNewPopup = true
      } else {
        this.termspopup = true
      }
    },
    getTermsCondition () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'helper/termsAndConditionsPopupV2?COMPANY=' + this.haaid, data, { headers }, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.termsdata = res
          this.termslink = this.termsdata.LINK
          this.termslabel = this.termsdata.LABEL
          this.termspopupText = this.termsdata.HTML
          var labelarroriginal = this.termsdata.LABEL.split(' ')
          var labelarr = this.termsdata.LABEL.split(' ')
          labelarr.pop()
          this.termslabel = labelarr.join(' ')
          this.termslinkablework = labelarroriginal[labelarroriginal.length - 1]
        },
        response => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    opensignature () {
      // if (this.daystofinish === '') {
      //   this.$message.error('Angiv venligst dit anslåede antal uger for at afslutte jobbet')
      //   return
      // }
      // if (this.datestart === '') {
      //   this.$message.error('Tilføj venligst hvornår du starter jobbet, når tilbuddet er accepteret')
      //   return
      // }
      this.$refs['signaturepopup'].show()
      this.initiateSignaturepad()
    },
    openrequestmodal (id) {
      this.selectedindustryforrequest = id
      this.$refs['successrequest'].show()
    },
    closerequestmodal () {
      this.$refs['successrequest'].hide()
    },
    clearSignature () {
      var signature = this.signaturePad
      signature.clear()
    },
    validateFirstTab () {
      var haspriceeach = Object.values(this.productOfferForm)
      if (haspriceeach.includes(0) || haspriceeach.includes(undefined)) {
        this.$message({
          type: 'error',
          message: 'Ugyldigt beløb. Beløbet skal være over 0kr'
        })
        return false
      }
      if (parseFloat(this.total * 1.25) < 1000) {
        this.$message.error('Samlet pris bør ikke være mindre end 1000 kr')
        return false
      }
      return true
    },
    validateSecondTab () {
      if (this.daystofinish > 1500 || this.daystofinish === null) {
        this.$message({
          type: 'error',
          message: 'dette er begrænset til 1500 dage'
        })
        return false
      }
      return true
    },
    validatethirdTab () {
      if (this.partnernote === '') {
        this.alertpartnernote = true
        return false
      }
      return true
    },
    submitOffer () {
      var signature = this.signaturePad
      if (signature.isEmpty()) {
        this.$message.error('Underskriv venligst dit tilbud')
        return
      }
      if (!this.confirmTerms) {
        this.$message.error('Bekræft venligst din tilbudsoversigt')
        return
      }
      // if (this.fiverecommendations.length < 1) {
      //   this.$message.error('Vælg venligst dine anmeldelser for at tilføje til dit tilbud')
      //   return
      // }
      this.signaturePng = signature.toDataURL()
      // if (this.contractType === 'Fagentreprise') {
      //   this.addOffereach()
      // } else {
      //   this.addOffer()
      // }
      // if (!this.$route.query.offerID && this.offerType === 'invitation') {
      //   this.addOffer()
      // } else if (!this.$route.query.offerID && this.offerType !== 'invitation') {
      if (this.$route.query.offerID) {
        this.updateOfferPrice()
      } else {
        this.addOffer()
      }
    },
    addtoanswers () {
      console.log('ss')
    },
    addOffereach (issubprojectID = false, subtotal = 0, subprojID = 0) {
      this.loading = true
      var productionformarr = Object.keys(this.productOfferForm)
      var offertitle = ''
      for (var jobwithpriceObj in this.productOfferForm) {
        var jobindustry = ''
        var jobindistryprojectID = ''
        var jobwithpriceArr = []
        var enterpriseId = ''
        jobwithpriceArr = jobwithpriceObj.split('_')
        jobindustry = jobwithpriceArr[1]
        enterpriseId = jobwithpriceArr[0]
        offertitle += this.mainwizarproductarr[enterpriseId] + '-' + this.itemsjobindustry[jobindustry] + ' '
        jobindistryprojectID = this.childprojectObj[Number(jobindustry)]
        this.closesignature()
        var gettotal = this.productOfferForm[jobwithpriceObj]
        var projId = jobindistryprojectID
        this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {
          projectId: projId,
          offers: [{
            title: 'Tilbud på projektnr. ' + projId + ' til ' + offertitle,
            description: this.partnernote,
            subtotalPrice: gettotal,
            vat: parseFloat(gettotal * 0.25),
            totalPrice: parseFloat(gettotal * 1.25),
            tasks: this.rowbolig
          }],
          bookWizardPartner: {
            project_id: this.parentID,
            sub_project_id: jobindistryprojectID,
            contact_id: this.contactID,
            calculation_id: 0,
            industry_id: enterpriseId,
            total: gettotal,
            note: this.partnernote,
            signature: this.signaturePng,
            weeks: this.daystofinish,
            parent_offer_id: this.parentofferId,
            job_industry_id: jobindustry,
            start_date: this.datestart,
            reviews_id: this.fiverecommendations
          }
        }
        this.$http.post(this.$bitrixapi + 'partner/offer', data, { headers }, { emulateJSON: true }).then(
          response => {
            // var res = response.body.data.offer
            // this.offerIDObj[enterpriseId] = res[0].ID
            // this.saveProjectPricev2(res[0].ID, jobwithpriceObj)
            if (jobwithpriceObj === productionformarr[productionformarr.length - 1]) {
              setTimeout(() => {
                let obj = {
                  title: 'Gennemført!',
                  message: '',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
              }, 1000)
              setTimeout(() => {
                this.$router.push('/alle-moeder')
              }, 3000)
            }
          },
          response => {
            var error = response.body.message
            this.$message({
              type: 'error',
              message: error
            })
          }
        )
      }
    },
    addOffer (issubprojectID = false, subtotal = 0, subprojID = 0) {
      this.closesignature()
      this.loading = true
      var offertitle = ''
      for (var jobwithpriceObj in this.productOfferForm) {
        var jobwithpriceArr = jobwithpriceObj.split('_')
        offertitle += this.mainwizarproductarr[jobwithpriceArr[0]] + '-' + this.itemsjobindustry[jobwithpriceArr[1]] + ' '
      }
      var gettotal = this.total
      var projId = this.$route.query.projectID
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        projectId: projId,
        offers: [{
          title: 'Tilbud på projektnr. ' + projId + ' til ' + offertitle,
          description: this.partnernote,
          subtotalPrice: gettotal,
          vat: parseFloat(gettotal * 0.25),
          totalPrice: parseFloat(gettotal * 1.25),
          tasks: this.rowbolig
        }]
      }
      if (this.submittedIndustries.length === 1 && this.submittedIndustries[0] === '1062') {
        data.parentProjectId = this.parentID
        data.jobIndustry = '1062'
      }
      this.$http.post(this.$bitrixapi + 'partner/offer', data, { headers }, { emulateJSON: true }).then(
        response => {
          var res = response.body.data.offer
          // if (!issubprojectID) {
          //   // this.offerID = res[0].ID
          //   // this.saveProjectPrice()
          // }
          this.parentofferId = res[0].ID
          if (this.contractType === 'Fagentreprise') {
            this.saveProjectPricev3()
          } else {
            this.saveProjectPrice()
          }
        },
        response => {
          this.loading = false
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    updateOfferPrice (issubprojectID = false, subtotal = 0, subprojID = 0) {
      this.closesignature()
      this.loading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        total: Number(this.total * 1.25),
        subTotal: this.total,
        vat: Number(this.total * 0.25)
      }
      this.$http.put(this.$bitrixapi + 'partner/offer/' + this.offerID, data, { headers }, { emulateJSON: true }).then(
        response => {
          this.updatePriceList()
        },
        response => {
          this.loading = false
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    requestToHomeowner (wizardid, jobindustry) {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        wizardId: wizardid,
        projectId: this.projectID,
        contactId: this.contactID,
        jobIndustryId: Number(jobindustry),
        industry: this.partnerprimaryindustryText ? this.partnerprimaryindustryText : 'ukendt'
      }
      this.$http.post(this.$bitrixapi + 'partner/message/sendRequestOffer', data, { headers }, { emulateJSON: true }).then(
        response => {
          let obj = {
            title: 'Gennemført!',
            message: 'Hvis boligejeren ønsker et tilbud fra dig, vil du få besked om dette.',
            type: 'success',
            customCloseBtnText: 'Luk'
          }
          this.$refs.simplert.openSimplert(obj)
        },
        err => {
          var error = err.body.message
          this.$message.error(error)
        })
    },
    limitdays () {
      if (this.daystofinish > 1500) {
        this.limitdayserror = true
        return
      }
      this.limitdayserror = false
    }
  }
}
</script>
<style>
#TermsNewPopup .modal-dialog {
  max-width: 833px;
}
#TermsNewPopup___BV_modal_content_ {
  width: 900px;
}
#createofferwizard .wizard-progress-with-circle {
  display: block!important;
}
#createofferwizard .vue-form-wizard.lg .wizard-navigation .wizard-progress-with-circle, .vue-form-wizard .wizard-nav-pills {
  display: flex!important;
}
#allofferproduct .vue-form-wizard.md .wizard-nav-pills>li.active>a .wizard-icon {
    font-style: normal;
    font-weight: 500;
  }
#allofferproduct .vue-form-wizard.md .wizard-icon-circle {
  width: 50px;
  height: 50px;
  font-size: 14px;
  font-style: normal;
  color: #ffff;
  background-color: #CECECE;
}
#allofferproduct .vue-form-wizard .wizard-card-footer {
  display: unset;
}
#allofferproduct .wizard-icon-circle+.checked {
  color: #ffff!important;
}
#allofferproduct .vue-form-wizard .wizard-nav {
    margin-bottom: 30px;
}
#allofferproduct .wizard-nav li .checked+.stepTitle {
    color: #19A3C080;
    border: none;
}
#allofferproduct .wizard-nav li .stepTitle {
  border: none;
}
#allofferproduct .wizard-nav li .stepTitle {
    text-align: center;
    font-style: normal;
}
#allofferproduct .wizard-progress-bar {
    top: -9px;
    height: 4px;
    position: absolute;
}
#allofferproduct .wizard-icon-circle.checked {
  background: rgb(25, 163, 192)!important;
  color: #fff;
  font-style: normal;
}
#allofferproduct .el-date-editor {
  width: 100%!important;
}
#reviewsmodal .reviewbox {
  border-style: double;
  border-width: 5px;
  border-color:#12ef12;
}
#signature-pad {
  height: 300px;
  width: 550px;
}
#signaturepopup___BV_modal_body_ .modal-body {
  padding: 20px!important;
}
#reviewsmodal .reviewsoffer {
    height: 340px;
    width: 250px;
}
#allofferproduct .el-collapse-item__header {
  background-color: rgba(0, 54, 69, 1.0);
  color: #fff;
}
#termspopup .modal-body {
  height:800px;
}
#termspopup .modal-content {
  width:1200px;
}
#termspopup {
  left: -20%!important;
}
#signaturepopup .modal-content .modal-body {
  padding: 17px;
}
#allofferproduct .el-input__icon {
  line-height : 30px;
}
#allofferproduct .el-input__inner {
  border-color: #19A3C0;
}
#allofferproduct .el-form-item__error {
  font-size: 11px;
}
#allofferproduct .el-checkbox__inner {
  border-radius: 20px;
}
#allofferproduct .el-input-number .el-input__inner {
  text-align: right;
  padding-right: 10px!important;
}
#allofferproduct .el-collapse-item__header {
  height: 48px!important;
}
#signaturepopup .saveSignature > .el-checkbox__inner {
  border-radius: 20px;
}
#clear-button {
  width: 55px;
  height: 22px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #FC0000;
  border-radius: 3px;
  opacity: 1;
  font: normal normal normal 8px/11px Noto Sans;
}
@media (max-width:40em) {
  .onmobilexd {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 16px #00000029;
    border: 1px solid #82d4e654;
    border-radius: 3px;
    color: #003645;
  }
  #reviewsmodal .reviewsoffer {
    height: 281px;
    width: 146px;
  }
  #allofferproduct .vue-form-wizard.md .wizard-icon-circle {
    width: 40px;
    height: 40px;
    font-size: 14px;
    font-style: normal;
  }
  #allofferproduct .vue-form-wizard.md .wizard-nav-pills>li.active>a .wizard-icon {
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
  }
  #allofferproduct .vue-form-wizard .wizard-tab-content {
    padding: 20px 0 0 0;
  }
  #TermsNewPopup___BV_modal_content_ {
    width: 100%;
  }
}
@media (min-width:125em) {
  #allofferproduct .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%!important;
  }
}
#allofferproduct .el-input-number__increase {
  display: none;
}
#allofferproduct .el-input-number__decrease {
  display: none;
}
#allofferproduct .el-input-number {
  width: inherit;
}
.daystofinish+.el-input-number {
  width: 100%;
}
#allofferproduct .el-input-number .el-input__inner {
  padding-left: 0px;
  padding-right: 0px;
}
#allofferproduct .loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
#allofferproduct .loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
#allofferproduct .loader:before,
.loader:after {
  position: absolute;
  content: '';
}
#allofferproduct .loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
#allofferproduct .loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
</style>



// WEBPACK FOOTER //
// standardTilbudProduct.vue?333e9fd1